export default __webpack_public_path__ + "static/media/background.7ce2f644.webp";